"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var index_1 = __importDefault(require("./autocomplete/index"));
var index_2 = __importDefault(require("./date/index"));
var Input = __importStar(require("./input"));
var input_number_1 = __importDefault(require("./input-number"));
var index_3 = __importDefault(require("./select/index"));
var switch_1 = __importDefault(require("./switch"));
var textarea_1 = __importDefault(require("./textarea"));
var code_1 = __importDefault(require("./code"));
var InputGeneric = function (props) {
    var field = props.field, data = props.data, onChange = props.onChange;
    var name = field.name, type = field.type, promise = field.promise, options = field.options, ux = field.ux, inputProps = field.inputProps, label = field.label;
    switch (ux || type) {
        case 'select':
        case 'enum':
            return (react_1["default"].createElement(index_3["default"], __assign({ promise: typeof promise === 'function' ? promise(data) : promise, name: name, data: data, onChange: onChange, options: typeof options === 'function' ? options(data) : options, shouldReturnOnlyId: type === 'enum' }, inputProps)));
        case 'boolean':
            return (react_1["default"].createElement(switch_1["default"], __assign({ data: data, name: name, onChange: onChange }, inputProps)));
        case 'date':
            return (react_1["default"].createElement(index_2["default"], __assign({ data: data, name: name, onChange: onChange, label: label }, inputProps)));
        case 'number':
            return (react_1["default"].createElement(input_number_1["default"], __assign({ data: data, name: name, onChange: onChange }, inputProps)));
        case 'autocomplete':
            return (react_1["default"].createElement(index_1["default"], __assign({ promise: typeof promise === 'function' ? promise(data) : promise, data: data, name: name, options: typeof options === 'function' ? options(data) : options, onChange: onChange, label: label }, inputProps)));
        case 'textarea':
            return (react_1["default"].createElement(textarea_1["default"], __assign({ name: name, data: data, onChange: onChange }, inputProps)));
        case 'code':
            return (react_1["default"].createElement(code_1["default"], __assign({ name: name, data: data, onChange: onChange }, inputProps)));
        default: {
            var type_1 = ux && Input.Utils.isInputType(ux) ? ux : undefined;
            return (react_1["default"].createElement(Input.UI, __assign({ type: type_1, name: name, data: data, onChange: onChange }, inputProps)));
        }
    }
};
exports["default"] = InputGeneric;
